module.exports = __webpack_public_path__ + "static/media/taxRates.49961d0e.svg";